module.exports = __webpack_public_path__ + "static/media/Step4.6c40d58d.png";